<template>
  <section-wrapper class="bg-background-3">
    <section-container
      mobile-padding
      class="max-w-container prose-funargos prose relative z-[1] justify-center py-20"
    >
      <!-- Titre principal H1 -->
      <div class="text-primary mb-20 text-[3rem] font-bold leading-[3.5rem]">
        POLITIQUE DE PROTECTION DES DONNÉES PERSONNELLES
      </div>

      <!-- Sous-titre H2 -->
      <section-title class="mb-5">PRÉAMBULE </section-title>

      <!-- Corps du texte -->
      <p>
        Le présent document « Politique de protection des Données Personnelles »
        concerne toute personne physique (ci-après « les Personnes Physiques »)
        dont les Données Personnelles seraient traitées par FUNERE SAS (« Nous
        ») conformément aux dispositions du Règlement Général sur la Protection
        des Données (RGPD) adopté le 27 avril 2016 par le Parlement européen et
        le Conseil.
      </p>
      <p>
        Dans le cadre de votre visite sur notre site internet et lors de
        l’utilisation de la plateforme Funargos, FUNERE SAS recueille vos
        Données Personnelles afin de les utiliser dans différents traitements
        automatisés.
      </p>

      <!-- Autres sous-titres et paragraphes suivent de la même manière -->
      <section-title class="mb-5"
        >I- Le traitement de vos Données Personnelles
      </section-title>
      <h3 class="text-primary">1) Définitions</h3>
      <ul>
        <li>
          <b>Donnée à caractère personnel</b> (ci-après « Données Personnelles
          ») désigne toute information susceptible de se rapporter à une
          personne physique identifiée ou identifiable directement ou
          indirectement.
        </li>
        <li>
          <b>DPO :</b> Le délégué à la protection des données (DPO) est chargé
          de mettre en œuvre la conformité au règlement européen sur la
          protection des données au sein de l’organisme qui l’a désigné
          s’agissant de l’ensemble des traitements mis en œuvre par cet
          organisme.
        </li>
        <li>
          <b>Responsable du traitement :</b> Le responsable de traitement, ici
          FUNERE SAS, est la personne morale ou physique qui détermine les
          finalités et les moyens d’un traitement. En pratique et en général, il
          s’agit de la personne morale incarnée par son représentant légal.
        </li>
      </ul>
      <h3 class="text-primary">2) Nos engagements</h3>
      <p>
        Nous traitons vos Données Personnelles conformément aux dispositions du
        Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril
        2016 relatif à la protection des personnes physiques à l’égard du
        traitement des données à caractère personnel et à la libre circulation
        de ces données, ci-après désigné « RGPD ».
      </p>
      <p>
        FUNERE SAS s’engage à œuvrer à la protection de vos données
        personnelles. Seul notre personnel habilité et formé au respect des
        règles de confidentialité participe à l'exploitation du site et de la
        plateforme Funargos. ».
      </p>
      <p>
        De plus, FUNERE SAS met en place les mesures techniques et
        organisationnelles appropriées pour éviter la perte, la mauvaise
        utilisation, l’altération et la suppression de vos données personnelles.
        Ces mesures sont adaptées selon le niveau de sensibilité des données
        traitées et le niveau de risque que présente le traitement ou sa mise en
        œuvre. Si une atteinte à la sécurité des données vous concernant se
        produit, FUNERE SAS vous en informera dans les délais et selon les
        modalités précisées par les dispositions légales et règlementaires en
        vigueur.
      </p>
      <p>
        L’article 13 dudit règlement nous impose de vous informer sur les
        éléments suivants :
      </p>
      <ul>
        <li>
          L'identité et les coordonnées du responsable du traitement et, le cas
          échéant, du représentant du responsable du traitement.
        </li>
        <li>
          Les destinataires ou les catégories de destinataires des Données
          Personnelles, s'ils existent.
        </li>
        <li>
          La durée de conservation des Données Personnelles ou, lorsque ce n'est
          pas possible, les critères utilisés pour déterminer cette durée.
        </li>
      </ul>
      <section-title class="mb-5"
        >II- LES DONNÉES PERSONNELLES QUE NOUS TRAITONS
      </section-title>
      <p>Nous collectons et traitons les Données Personnelles suivantes :</p>
      <h3 class="text-primary">
        Les données collectées lors de votre inscriptions sur le site
      </h3>
      <table>
        <thead>
          <tr>
            <th class="text-primary text-left">
              Données Personnelles collectées
            </th>
            <th class="text-primary text-left">Finalité</th>
            <th class="text-primary text-left">Base légale</th>
            <th class="text-primary text-left">Durée de conservation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul>
                <li>Nom de l’entreprise</li>
                <li>Prénom</li>
                <li>Nom</li>
                <li>Adresse email</li>
                <li>Adresse postale</li>
                <li>Code postale</li>
                <li>Téléphone fixe et mobile</li>
                <li>IBAN</li>
                <li>Kbis</li>
              </ul>
            </td>
            <td>Permettre la création de votre compte sur Funargos</td>
            <td>Consentement</td>
            <td>
              Le temps de notre relation contractuelle puis 3 ans après la fin
              de celle-ci
            </td>
          </tr>
        </tbody>
      </table>
      <h3 class="text-primary">
        Les données collectées lors de votre utilisation de la plateforme
        Funargos
      </h3>
      <table>
        <thead>
          <tr>
            <th class="text-primary text-left">
              Données Personnelles collectées
            </th>
            <th class="text-primary text-left">Finalité</th>
            <th class="text-primary text-left">Base légale</th>
            <th class="text-primary text-left">Durée de conservation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul>
                <li>Lieu de départ et d’arrivée du convoi</li>
                <li>Nom</li>
                <li>Prénom</li>
                <li>Numéro de téléphone</li>
                <li>Plaque d’immatriculation</li>
              </ul>
            </td>
            <td>Permettre l’utilisation de la plateforme Funargos</td>
            <td>Consentement</td>
            <td>
              Le temps de notre relation contractuelle puis 3 ans après la fin
              de celle-ci
            </td>
          </tr>
        </tbody>
      </table>
      <h3 class="text-primary">
        Les données enregistrées quand vous naviguez sur notre site
      </h3>
      <table>
        <thead>
          <tr>
            <th class="text-primary text-left">
              Données Personnelles collectées
            </th>
            <th class="text-primary text-left">Finalité</th>
            <th class="text-primary text-left">Base légale</th>
            <th class="text-primary text-left">Durée de conservation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Adresse IP</td>
            <td>Gestion des informations de navigation des visiteurs</td>
            <td>Intérêt légitime</td>
            <td>3 ans</td>
          </tr>
        </tbody>
      </table>
      <h3 class="text-primary">Cookies</h3>
      <table>
        <thead>
          <tr>
            <th class="text-primary text-left">Nom</th>
            <th class="text-primary text-left">Finalité</th>
            <th class="text-primary text-left">Base légale</th>
            <th class="text-primary text-left">Durée de conservation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>__stripe_sid</td>
            <td>Assure la prévention de fraude.(Stripe)</td>
            <td>Consentement</td>
            <td>1 jours</td>
          </tr>
          <tr>
            <td>__stripe_mid</td>
            <td>Assure la prévention de fraude.(Stripe)</td>
            <td>Consentement</td>
            <td>1 ans</td>
          </tr>
          <tr>
            <td>_ga</td>
            <td>Stocke et compte les pages vues.(Google Analytics)</td>
            <td>Consentement</td>
            <td>1 ans</td>
          </tr>
          <tr>
            <td>_ga_XXXXXXXXXX</td>
            <td>
              Identifie de façon unique les utilisateurs. Collecte des
              stats.(Google Analytics)
            </td>
            <td>Consentement</td>
            <td>1 ans</td>
          </tr>
        </tbody>
      </table>
      <section-title class="mb-5"
        >III- LES DESTINATAIRES DES DONNÉES PERSONNELLES
      </section-title>
      <p>
        Les données personnelles collectées sur le site de et la plateforme
        Funargos sont destinées principalement à FUNERE SAS, toutefois elles
        sont susceptibles d'être partagées avec nos partenaires. Afin de pouvoir
        réaliser notamment la maintenance du site et de la plateforme Funargos,
        certaines de vos données sont susceptibles d'être partagées également
        avec nos sous-traitants.
      </p>
      <p>
        Nous nous assurons que tous nos partenaires et sous-traitants soient
        soumis à des mécanismes de protection des données personnelles adéquates
        et conformes au Règlement RGPD et que les données seront traitées
        uniquement par le personnel habilité et tenu par une clause de
        confidentialité ou tout autre document contractuel équivalent.
      </p>
      <section-title class="mb-5"
        >IV- L’EXERCICE DE VOS DROITS RGPD
      </section-title>
      <h3 class="text-primary">
        1) Droit d’accès et à la rectification de vos données
      </h3>
      <p>
        Vous disposez du droit d'obtenir du responsable du traitement la
        confirmation que des Données Personnelles vous concernant sont ou ne
        sont pas traitées et, lorsqu'elles le sont, du droit d’y accéder et/ou
        de les faire rectifier. (Voir articles 15 et 16 du RGPD.)
      </p>
      <h3 class="text-primary">2) Droit à l’effacement de vos données</h3>
      <p>
        Conformément à l’article 17 du RGPD vous avez le droit de nous demander
        l’effacement, dans les meilleurs délais, de vos Données Personnelles ;
        pour certains motifs/ selon certaines conditions que vous pouvez
        consulter audit article/ dans les cas prévus par l’article.
      </p>
      <h3 class="text-primary">
        3) Droit à la limitation des traitements de données
      </h3>
      <p>
        Vous avez le droit de nous demander la limitation du traitement de vos
        Données Personnelles dans les cas prévus par l’article 18 du RGPD.
      </p>
      <h3 class="text-primary">
        4) Droit de vous opposer aux traitements de données.
      </h3>
      <p>
        Conformément à l’article 21 du RGPD, vous avez le droit de vous opposer
        à un traitement de Données Personnelles vous concernant lorsque le
        traitement est nécessaire aux fins des intérêts légitimes poursuivis par
        le responsable du traitement ou par un tiers, à moins que ne prévalent
        les intérêts ou les libertés et droits fondamentaux de la personne
        concernée qui exigent une protection des Données Personnelles, notamment
        lorsque la personne concernée est un enfant.
      </p>
      <h3 class="text-primary">5) Droit à la portabilité de vos données.</h3>
      <p>
        Vous disposez du droit à la portabilité de vos Données Personnelles, qui
        vous donne la possibilité de recevoir les Données Personnelles que vous
        nous avez fournies, dans un format structuré, couramment utilisé et
        lisible par machine, ainsi que la possibilité de transmettre ces données
        à un autre responsable du traitement. L’exercice de ce droit sera soumis
        à des conditions prévues par l’article 20 du RGPD.
      </p>
      <h3 class="text-primary">6) Droit de retirer votre consentement.</h3>
      <p>
        Conformément à l’article 7 du RGPD, dans les cas où le traitement repose
        sur le consentement, vous avez le droit de retirer votre consentement à
        tout moment. Ceci mettra fin au traitement de vos données.
      </p>
      <h3 class="text-primary">
        7) Droit de définir des directives post-mortem.
      </h3>
      <p>
        Vous avez la possibilité de définir des directives relatives à la
        conservation, à l’effacement et à la communication de vos Données
        Personnelles après votre décès et ce auprès d’un tiers de confiance,
        certifié et chargé de faire respecter la volonté du défunt conformément
        aux exigences du cadre juridique applicable (Article 85 de la Loi n°
        78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
        libertés.)
      </p>
      <p>
        Vous pouvez exercer vos droits comme suit : En envoyant votre demande à
        l’adresse email suivante :
        <a href="mailto:privacy@funargos.fr">privacy@funargos.fr</a> ou par
        courrier accompagné d’une copie d’un document d’identité en s’adressant
        à FUNERE SAS à l’adresse suivante : 6 AV SAINT ROCH, 38000 GRENOBLE.
        Vous pouvez aussi introduire une réclamation auprès de la CNIL.
      </p>
      <section-title class="mb-5">Mise à jour </section-title>
      <p>
        Afin de respecter les modifications réglementaires et de refléter nos
        pratiques nous nous réservons le droit de modifier la présente
        politique. Nous publierons les modifications dans le présent document,
        nous vous conseillons de consulter régulièrement notre politique de
        confidentialité.
      </p>
      <b>Date de la dernière mise à jour :</b> 10/01/2024
    </section-container>
  </section-wrapper>
</template>
<script setup></script>
